/* global I18n */

import {use_configuration} from "./configuration_provider"
import CheckboxEntry from "./checkbox_entry"
import React from "react"

function MuscleFactsTags({tags}) {
  const {configuration, update_configuration} = use_configuration()
  const {excluded_muscle_facts} = configuration

  function handle_change(tag) {
    let muscle_facts
    if (excluded_muscle_facts.includes(tag)) {
      muscle_facts = excluded_muscle_facts.filter(fact => fact !== tag)
    } else {
      muscle_facts = [...excluded_muscle_facts, tag]
    }
    if (muscle_facts.length === tags.length) return

    update_configuration({excluded_muscle_facts: muscle_facts})
  }

  return (
    <div className="checkboxes">
      {tags.map(tag => (
        <CheckboxEntry
          key={tag}
          checked={!excluded_muscle_facts.includes(tag)}
          label={I18n.t(`js.quiz_mode_selector.muscle_facts.${tag}`)}
          onChange={() => handle_change(tag)}
        />
      ))}
    </div>
  )
}

export default MuscleFactsTags
